(function() {
  var configured = false;
  var maxAttempts = 120;
  var intervalMs = 250;
  var productCache = {};
  var sampleVariantIds = {};

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TWD';
  }

  function getCheckoutUrl() {
    return absoluteUrl('/checkout');
  }

  function getShopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;

    if (!root) {
      return '/';
    }

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function getShopifyUrl(path) {
    return getShopifyRoot() + path.replace(/^\//, '');
  }

  function absoluteUrl(url) {
    if (!url) {
      return '';
    }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    }

    return window.location.origin + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function fetchJson(url, options) {
    return window.fetch(url, options).then(function(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(json) {
        if (!response.ok) {
          throw new Error(json.description || json.message || 'Cart update failed.');
        }

        return json;
      });
    });
  }

  function fetchCart() {
    return fetchJson(getShopifyUrl('cart.js'), {
      credentials: 'same-origin'
    });
  }

  function normalizeMoney(value) {
    var amount = Number(value);

    if (!Number.isFinite(amount)) {
      return 0;
    }

    return amount / 100;
  }

  function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isSampleOptionValue(value) {
    var normalizedValue = normalizeOptionValue(value);

    return normalizedValue.indexOf('sample') !== -1 ||
      normalizedValue.indexOf('樣品') !== -1 ||
      normalizedValue.indexOf('样品') !== -1;
  }

  function isSampleVariant(variant) {
    return Boolean(variant && (variant.options || []).some(isSampleOptionValue));
  }

  function rememberSampleVariant(variant) {
    if (!variant || !variant.id) {
      return;
    }

    sampleVariantIds[String(variant.id)] = true;
  }

  function filterSampleVariants(variants) {
    return (variants || []).filter(function(variant) {
      if (isSampleVariant(variant)) {
        rememberSampleVariant(variant);
        return false;
      }

      return true;
    });
  }

  function isSampleCartItem(item) {
    if (!item) {
      return false;
    }

    if ((item.variant_options || []).some(isSampleOptionValue)) {
      return true;
    }

    return (item.options_with_values || []).some(function(option) {
      return option && isSampleOptionValue(option.value);
    });
  }

  function getImageUrl(image) {
    if (!image) {
      return '';
    }

    if (typeof image === 'string') {
      return image;
    }

    return image.src || image.url || '';
  }

  function getImageId(image, fallback) {
    if (image && typeof image === 'object' && image.id) {
      return String(image.id);
    }

    return String(fallback);
  }

  function getOptionName(option, index) {
    if (!option) {
      return 'Option ' + (index + 1);
    }

    return option.name || String(option);
  }

  function getVariantUrl(product, variant) {
    return absoluteUrl(getShopifyUrl('products/' + product.handle + '?variant=' + variant.id));
  }

  function createProductFromShopifyProduct(product) {
    var shopping = window._fwn && window._fwn.shopping;

    if (!shopping || typeof shopping.productFactory !== 'function' || !product || !product.id) {
      return null;
    }

    var variants = filterSampleVariants(product.variants);

    if (!variants.length) {
      return null;
    }

    return shopping.productFactory(function(builder) {
      builder
        .description(product.description || '')
        .extId(String(product.id))
        .name(product.title || '')
        .currency(getCurrency());

      variants.forEach(function(variant, index) {
        var image = variant.featured_image || product.featured_image || (product.images && product.images[0]);

        builder.variant(function(variantBuilder) {
          variantBuilder
            .extId(String(variant.id))
            .url(getVariantUrl(product, variant))
            .price(normalizeMoney(variant.price))
            .sku(variant.sku || '')
            .name(variant.title || product.title || '')
            .isAvailable(Boolean(variant.available))
            .position(index + 1);

          if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
            variantBuilder.originalPrice(normalizeMoney(variant.compare_at_price));
          }

          if (image) {
            variantBuilder.image(function(imageBuilder) {
              imageBuilder
                .extId(getImageId(image, variant.id))
                .position((image && image.position) || index + 1)
                .title((image && image.alt) || product.title || '')
                .url(absoluteUrl(getImageUrl(image)));
            });
          }

          (variant.options || []).forEach(function(value, optionIndex) {
            if (!value) {
              return;
            }

            variantBuilder.option({
              name: getOptionName((product.options || [])[optionIndex], optionIndex),
              value: value
            });
          });
        });
      });
    });
  }

  function createProductFromCartItem(item) {
    var shopping = window._fwn && window._fwn.shopping;

    if (!shopping || typeof shopping.productFactory !== 'function' || !item || isSampleCartItem(item)) {
      return null;
    }

    return shopping.productFactory(function(builder) {
      builder
        .description(item.product_description || '')
        .extId(String(item.product_id))
        .name(item.product_title || item.title || '')
        .currency(getCurrency());

      builder.variant(function(variantBuilder) {
        variantBuilder
          .extId(String(item.variant_id || item.id))
          .url(absoluteUrl(item.url))
          .price(normalizeMoney(item.final_price || item.price))
          .sku(item.sku || '')
          .name(item.variant_title || item.title || '')
          .isAvailable(true)
          .position(1);

        if (item.original_price && Number(item.original_price) > Number(item.final_price || item.price)) {
          variantBuilder.originalPrice(normalizeMoney(item.original_price));
        }

        if (item.featured_image || item.image) {
          variantBuilder.image(function(imageBuilder) {
            imageBuilder
              .extId(getImageId(item.featured_image, item.variant_id || item.id))
              .position(1)
              .title((item.featured_image && item.featured_image.alt) || item.product_title || item.title || '')
              .url(absoluteUrl(getImageUrl(item.featured_image) || item.image));
          });
        }

        (item.options_with_values || []).forEach(function(option) {
          if (!option || !option.value) {
            return;
          }

          variantBuilder.option({
            name: option.name,
            value: option.value
          });
        });
      });
    });
  }

  function extractProductHandle(product) {
    var possibleUrl = product && (product.url || product.product_url || product.productUrl || product.web_url);
    var match = possibleUrl && String(possibleUrl).match(/\/products\/([^/?#]+)/);

    if (match && match[1]) {
      return match[1];
    }

    if (product && product.product_handle) {
      return product.product_handle;
    }

    if (product && product.handle) {
      return product.handle;
    }

    if (product && product.product_ext_id && !/^\d+$/.test(String(product.product_ext_id))) {
      return product.product_ext_id;
    }

    return '';
  }

  function fetchShopifyProduct(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (!productCache[handle]) {
      productCache[handle] = fetchJson(getShopifyUrl('products/' + encodeURIComponent(handle) + '.js'), {
        credentials: 'same-origin'
      }).catch(function(error) {
        delete productCache[handle];
        throw error;
      });
    }

    return productCache[handle];
  }

  function hydrateProducts(payload) {
    var products = (payload && payload.products) || payload || [];

    if (!Array.isArray(products)) {
      return Promise.resolve([]);
    }

    return Promise.all(products.map(function(product) {
      var handle = extractProductHandle(product);

      return fetchShopifyProduct(handle).then(function(shopifyProduct) {
        return createProductFromShopifyProduct(shopifyProduct);
      }).catch(function() {
        return null;
      });
    })).then(function(hydratedProducts) {
      return hydratedProducts.filter(Boolean);
    });
  }

  function getProductUnitId(productUnit) {
    var id = productUnit && (
      productUnit.unit_ext_id ||
      productUnit.unitExtId ||
      productUnit.ext_id ||
      productUnit.extId ||
      productUnit.id ||
      productUnit.variant_id
    );
    var match = id && String(id).match(/\d+/g);

    if (!match || !match.length) {
      return null;
    }

    return Number(match[match.length - 1]);
  }

  function getVariantQuantity(cart, variantId) {
    return (cart.items || []).reduce(function(total, item) {
      return String(item.variant_id) === String(variantId) ? total + item.quantity : total;
    }, 0);
  }

  function refreshThemeCart() {
    if (!window.theme || !window.theme.miniCart) {
      return;
    }

    if (typeof window.theme.miniCart.updateElements === 'function') {
      window.theme.miniCart.updateElements();
    }

    if (typeof window.theme.miniCart.generateCart === 'function') {
      window.theme.miniCart.generateCart();
    }
  }

  function addCartItem(variantId, quantity) {
    return fetchJson(getShopifyUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    });
  }

  function changeCartItem(item, quantity) {
    return fetchJson(getShopifyUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: item.key || item.variant_id || item.id,
        quantity: quantity
      })
    });
  }

  function assertVariantIsNotSample(product, variantId) {
    if (sampleVariantIds[String(variantId)]) {
      return Promise.reject(new Error('樣品選項不開放加入購物車。'));
    }

    var handle = extractProductHandle(product);

    if (!handle) {
      return Promise.resolve();
    }

    return fetchShopifyProduct(handle).then(function(shopifyProduct) {
      var variant = shopifyProduct && (shopifyProduct.variants || []).find(function(shopifyVariant) {
        return String(shopifyVariant.id) === String(variantId);
      });

      if (isSampleVariant(variant)) {
        rememberSampleVariant(variant);
        throw new Error('樣品選項不開放加入購物車。');
      }
    });
  }

  function updateCartFromFirework(payload, productUnitArg, quantityArg) {
    var product = payload && payload.product ? payload.product : payload;
    var productUnit = payload && payload.productUnit ? payload.productUnit : productUnitArg;
    var quantity = payload && Object.prototype.hasOwnProperty.call(payload, 'quantity') ? payload.quantity : quantityArg;
    var variantId = getProductUnitId(productUnit);

    quantity = Math.max(0, Number(quantity) || 0);

    if (!variantId) {
      throw new Error('Missing Shopify variant ID.');
    }

    return assertVariantIsNotSample(product, variantId)
      .then(fetchCart)
      .then(function(cart) {
        var existingItem = (cart.items || []).find(function(item) {
          return String(item.variant_id) === String(variantId);
        });

        if (existingItem) {
          return changeCartItem(existingItem, quantity);
        }

        if (quantity === 0) {
          return cart;
        }

        return addCartItem(variantId, quantity).then(fetchCart);
      })
      .then(function(cart) {
        refreshThemeCart();
        return getVariantQuantity(cart, variantId);
      });
  }

  function getFireworkCartItems() {
    return fetchCart().then(function(cart) {
      return (cart.items || []).filter(function(item) {
        if (isSampleCartItem(item)) {
          sampleVariantIds[String(item.variant_id || item.id)] = true;
          return false;
        }

        return true;
      }).map(function(item) {
        return {
          product: createProductFromCartItem(item),
          unitId: String(item.variant_id || item.id),
          quantity: item.quantity
        };
      }).filter(function(item) {
        return item.product;
      });
    });
  }

  function configureFireworkCart() {
    var shopping = window._fwn && window._fwn.shopping;

    if (configured || !shopping || typeof shopping.configureCart !== 'function') {
      return configured;
    }

    shopping.configureCart({
      url: getCheckoutUrl(),
      currency: getCurrency(),
      addToCartText: '加入購物車',
      hydrationMode: 'replace'
    });

    if (typeof shopping.onProductsLoaded === 'function') {
      shopping.onProductsLoaded(hydrateProducts);
    }

    if (typeof shopping.onCartDisplayed === 'function') {
      shopping.onCartDisplayed(getFireworkCartItems);
    }

    if (typeof shopping.onCartUpdated === 'function') {
      shopping.onCartUpdated(updateCartFromFirework);
    }

    configured = true;
    return true;
  }

  function waitForFireworkShopping() {
    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;

      if (configureFireworkCart() || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, intervalMs);
  }

  window.addEventListener('fw:ready', configureFireworkCart);
  window.addEventListener('fw:shopping:ready', configureFireworkCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForFireworkShopping);
  } else {
    waitForFireworkShopping();
  }
})();
